import { useState } from "react";

import { Box } from "@mui/material";
import LandingFooter from "../components/LandingFooter";
import KwikScoutLogo from "../components/onboarding/KwikScoutLogo";
import ProgressBar from "../components/onboarding/ProgressBar";
import Step1AdminData from "../components/onboarding/Step1AdminData";
import Step2ValidateToken from "../components/onboarding/Step2ValidateToken";
import Step3TermsAndConditions from "../components/onboarding/Step3TermsAndConditions";
import Step4CollaboratorData from "../components/onboarding/Step4CollaboratorData";
import Step5Success from "../components/onboarding/Step5Success";
import LoginScreen from "../components/onboarding/LoginScreen";

const stepLabels = [
  "Dados do Administrador",
  "Validação do código de segurança",
  "Nossos termos e condições de uso",
  "Configure seu primeiro número",
];

const LandingTestContent = ({initialStep}) => {
  const [step, setStep] = useState(initialStep || 1);
  const [data, setData] = useState({
    session_id: null,
    expiration_timeout: 0,
    retry_timeout: 0,
    requested_at_ms: 0,
    adminData: {}
  })

  return (
    <div className="bg-background flex flex-col">
      <div className="w-full max-w-2xl mx-auto px-4 pt-10 pb-6">
        <KwikScoutLogo />
        {step <= 4 && (
          <ProgressBar step={step} totalSteps={4} label={stepLabels[step - 1]} />
        )}
      </div>

      <div className="flex-1 flex items-start justify-center px-4 pb-10">
        {step === 1 && <Step1AdminData setSession={(session_data) => setData(session_data)} onNext={() => setStep(2)} onLogin={()=> setStep(5)}/>}
        {step === 2 && <Step2ValidateToken data={data} onNext={() => setStep(3)} onBack={() => setStep(1)} />}
        {step === 3 && <Step3TermsAndConditions data={data} onNext={() => setStep(4)} />}
        {step === 4 && <Step4CollaboratorData restart={()=>setStep(1)} sessionId={data.session_id} sessionData={data.adminData} onNext={() => setStep(5)} />}
        {step === 5 && <Step5Success />}
        {step === 6 && <LoginScreen setSession={(session_data) => setData(session_data)} onNext={() => setStep(7)} goBack={()=>setStep(1)} />}
        {step === 7 && <Step2ValidateToken data={data} onNext={() => setStep(4)} onBack={() => setStep(6)} login />}
      </div>
    </div>
  );
};

const LandingTestNow = ({step}) => {
  const initialStep = step || 1

	return (
		<Box className="landing">
      <LandingTestContent initialStep={initialStep} />
			<LandingFooter />
		</Box>
	)
}


export default LandingTestNow;
